module.exports = __webpack_public_path__ + "static/media/Opened.bb47f605.svg";